import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

import PartnerLogo from "../PartnerLogo";
import { ShareLinkedIn, ShareTwitter } from "../Share";
import slugify from "slugify";
import ActionButton from "../ActionButton";
import { connect } from "react-redux";
import { requestImageDownload } from "../../state/download/share-image";
import { useStaticQuery, graphql } from "gatsby";

const ReduxConnectedInsight = ({
  id,
  title,
  parentTitle = null,
  stat,
  source,
  description,
  inverted,
  i,
  path,
  centre,
  shareSizeLarge = false,
  sharePath = null,
  shareImage,
  onDownloadClicked,
  className
}) => {
  const siteData = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          siteUrl: url
        }
      }
    }
  `);

  let rootStyle = className || (inverted ? styles.rootInverted : styles.root);
  const slug = title ? slugify(title) : ``;

  if (centre) {
    rootStyle = `${styles.rootCentre} ${rootStyle} `;
  }

  if (!sharePath) {
    sharePath = `${path}${id}/${i}/#${slug || `i`}${i}`;
  }

  const shareUrl = `${siteData.site.siteMetadata.siteUrl}${sharePath}`;
  const shareTitle = parentTitle ? `${parentTitle} - ${title}` : title;

  return (
    <div className={rootStyle}>
      <a id={`${slug}${i}`} />
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        <hr className={styles.line} />
      </div>
      <dl className={styles.insight}>
        <dt className={styles.stat}>{stat}</dt>
        <dd className="description">{description}</dd>
      </dl>

      <div className={styles.sourceRoot}>
        {source ? (
          <h4 className={styles.source}>
            <span className={styles.sourceText}>Source</span>
            <PartnerLogo partner={source} white={false} />
          </h4>
        ) : (
          <span>&nbsp;</span>
        )}
        {path && (
          <div className={styles.shareLinks}>
            {shareImage && (
              <div className={styles.downloadIcon}>
                <ActionButton
                  onClick={e => {
                    e.preventDefault();
                    onDownloadClicked(shareImage.publicURL);
                  }}
                />
              </div>
            )}
            <div className={styles.shareIcon}>
              <ShareTwitter
                text={shareTitle}
                url={shareUrl}
                large={shareSizeLarge}
              />
            </div>
            <div className={styles.shareIcon}>
              <ShareLinkedIn
                url={shareUrl}
                sourceUrl={shareUrl}
                title={shareTitle}
                large={shareSizeLarge}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const withRedux = connect(
  () => ({}),
  dispatch => ({
    onDownloadClicked(url) {
      dispatch(
        requestImageDownload({
          url: url,
          filename: url.split(`/`).pop()
        })
      );
    }
  })
);

const Insight = withRedux(ReduxConnectedInsight);

Insight.defaultProps = {
  inverted: false
};

Insight.propTypes = {
  title: PropTypes.string,
  stat: PropTypes.string,
  source: PropTypes.string,
  description: PropTypes.string,
  inverted: PropTypes.bool,
  className: PropTypes.string
};

export default Insight;
